/* global define, tinymce */

window._define(
  'modules/postWrite',
  ['jquery', 'common/pubsub', 'widgets/tagsSelect', 'bridge/modules/wysiwyg'],
  function ($, pubsub, TagsSelect, wysiwygFromDom) {
    ('use strict');

    let isInit = false;

    const initWysiwyg = function () {
        const editorElement = document.querySelector('.js-wysiwyg-content textarea');

        if (!editorElement || isInit) {
          return;
        }

        isInit = true;

        wysiwygFromDom(editorElement, {
          menubar: false,
          plugins:
            'autoresize lists autolink link code table image -claireEmoticons -claireImages -claireCode',
          toolbar:
            'styleselect | fontsizeselect | bold italic forecolor | bullist numlist | link | claireImage | claireCodeBlock | claireEmoticons',
          min_height: 280,
          target_list: false,
          claireCode_simple_output: true,
        });
      },
      initUserSelector = function () {
        var $element = $('.js-user-select'),
          $label = $element.parent().find('label'),
          resultHtml =
            '<a>' +
            '  <img class="thumbnail" src="<%= avatar %>"/>' +
            '  <span><%= username %></span>' +
            '</a>',
          options = {
            dataMap: { label: 'username', value: 'username', icon: 'avatar' },
            itemTemplate: resultHtml,
            change: function () {
              // update label text, with plural if needed
              var amount = $(this).tagsSelect('getItems').length;
              $label.text($label.data('i18n')[amount < 2 ? 0 : 1]);
            },
            select: function (event, ui) {
              // var user = ui.item;
              event.stopPropagation();
            },
          },
          element = $('.js-user-select').get(0);

        if (element) {
          new TagsSelect(options, $('.js-user-select'));
        }
      },
      getQuotedPostMessage = function (postData) {
        var message =
          '<blockquote><cite>' +
          postData.author +
          ' a écrit:</cite><div>' +
          postData.content +
          '</div></blockquote>';
        return message;
      },
      scrollToElement = function (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      goWriteForm = function (textToAppend) {
        const messageForm = document.querySelector('.js-write-thread-form');
        messageForm.classList.add('write-thread-form--opened');

        initWysiwyg();

        const editor = window.tinymce?.activeEditor;

        if (textToAppend && editor) {
          editor.setContent(editor.getContent() + textToAppend);

          const endId = tinymce.DOM.uniqueId();

          // move cursor at the end of the editor
          editor.dom.add(editor.getBody(), 'span', { id: endId }, '<br data-mce-bogus="1" />');
          const newNode = editor.dom.select('span#' + endId);
          editor.selection.select(newNode[0]);

          editor.focus();
        }

        scrollToElement(messageForm);
      };

    // dom ready
    $(function () {
      if (!document.location.pathname.match(/\/mp\//)) {
        return;
      }
      initWysiwyg();
      initUserSelector();

      // register external events
      pubsub.subscribe('thread.post.action', function (eventName, data) {
        var action = data.action;

        switch (action) {
          case 'quote':
            goWriteForm(getQuotedPostMessage(data));

            break;

          case 'post-errors':
          case 'new':
            goWriteForm();
            break;
        }
      });
    });
  }
);
